import axios from 'axios';

export async function getBenchmark(uid: string) {
    let serviceResponse: any = null;

    const headers = {
        'Authorization': `UserToken ${uid}`,
    }

    try {
        const res = await axios.get(`${process.env.REACT_APP_SERVICE_URL}.premiertools.app/benchmark`, { headers});

        if (res.data && res.data.status === 200 && res.data.data) {
            serviceResponse = res.data.data;
            //console.log("Fetched solo options:", serviceResponse);
        } else {
            //console.error("Unexpected response structure:", res.data);
        }
    } catch (error: any) {
        //console.error("Error fetching configurations:", error.message);
        return null;
    }

    return serviceResponse;
}

export async function getReportPromotion(uid: string, id: string) {
    let serviceResponse: any = null;

    const headers = {
        'Authorization': `UserToken ${uid}`,
    }

    try {
        const res = await axios.get(`${process.env.REACT_APP_SERVICE_URL}.premiertools.app/benchmark/get/report/promotions`, { headers, params: { id: id } });

        if (res.data && res.data.status === 200 && res.data.data) {
            serviceResponse = res.data.data;
            //console.log("Fetched solo options:", serviceResponse);
        } else {
            console.error("Unexpected response structure:", res.data);
        }
    } catch (error: any) {
        //console.error("Error fetching configurations:", error.message);
        return null;
    }

    return serviceResponse;
}

export async function getBrandList(uid: string) {
    let serviceResponse: any = null;
    

    const headers = {
        'Authorization': `UserToken ${uid}`,
    }
    try {
        const res = await axios.get(`${process.env.REACT_APP_SERVICE_URL}.premiertools.app/barlleno/sap/brand/list`, { headers });

        if (res.data && res.data.status === 200 && res.data.data) {
            serviceResponse = res.data.data;
            //console.log("Fetched solo options:", serviceResponse);
        } else {
            console.error("Unexpected response structure:", res.data);
        }
    } catch (error: any) {
        //console.error("Error fetching configurations:", error.message);
        return null;
    }

    return serviceResponse;
}